import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';

/**
 * FR-01 — request a password reset link.
 *
 * The result is deliberately the same whether or not the address is
 * registered: a differing message would turn this form into a way to discover
 * which children have accounts.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(
        email.trim(),
        { redirectTo: `${window.location.origin}/reset-password` }
      );
      // A "user not found" is swallowed on purpose — see the note above. Only
      // a genuine transport failure is surfaced.
      if (resetError && !/not found|no user/i.test(resetError.message)) {
        throw resetError;
      }
      setSent(true);
    } catch (err: any) {
      setError(err.message || 'Gagal mengirim tautan. Coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="screen min-h-[100dvh] h-full">
        <div className="screen-card text-center" role="status">
          <div className="section-title">Cek email kamu</div>
          <div className="subtitle">
            Jika <strong>{email}</strong> terdaftar, kami sudah mengirim tautan
            untuk mengganti password.
          </div>
          <div className="next-actions" style={{ marginTop: 16, justifyContent: 'center' }}>
            <Link to="/login" className="btn-primary">
              Kembali ke halaman masuk
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="screen min-h-[100dvh] h-full">
      <div className="screen-card">
        <div className="section-title">Lupa password</div>
        <div className="subtitle">
          Masukkan email akunmu. Kami kirim tautan untuk membuat password baru.
        </div>
        <form onSubmit={handleSubmit}>
          <div className="field" style={{ marginTop: 12 }}>
            <label htmlFor="reset-email">Email</label>
            <input
              id="reset-email"
              type="email"
              required
              value={email}
              placeholder="contoh@email.com"
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          {error ? <div className="target-band-error">{error}</div> : null}
          <div className="target-actions" style={{ marginTop: 14 }}>
            <button type="submit" className="btn-primary" disabled={loading || !email.trim()}>
              {loading ? 'Mengirim...' : 'Kirim tautan'}
            </button>
            <Link to="/login" className="btn-secondary">
              Batal
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
